import { useMotionValueEvent, useScroll } from 'framer-motion';
import React, { useCallback, useEffect, useState } from 'react';

import IndicatorItem, { IndicatorItemType } from './IndicatorItem';

type Props = {
  items: IndicatorItemType[];
};

export default function Indicator({ items }: Props) {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const { scrollY } = useScroll();

  const updateActiveIndex = useCallback(() => {
    const viewportCenter = window.innerHeight / 2;
    const nextIndex = items.reduce((currentIndex, item, index) => {
      const section = document.querySelector<HTMLElement>(item.href);
      if (!section) return currentIndex;

      return section.getBoundingClientRect().top <= viewportCenter
        ? index
        : currentIndex;
    }, 0);

    setActiveIndex((currentIndex) =>
      currentIndex === nextIndex ? currentIndex : nextIndex,
    );
  }, [items]);

  useMotionValueEvent(scrollY, 'change', updateActiveIndex);

  useEffect(() => {
    const animationFrame = requestAnimationFrame(updateActiveIndex);
    window.addEventListener('resize', updateActiveIndex);
    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener('resize', updateActiveIndex);
    };
  }, [updateActiveIndex]);

  return (
    <div className="sticky top-[100px] flex h-fit flex-col">
      {items.map((item, index) => (
        <IndicatorItem key={index} isActive={index === activeIndex} {...item} />
      ))}
    </div>
  );
}
